
import * as React from 'react';
import { injectInitialProps } from '../../../utilities/components/Props';
import { IUploaderProps } from '../../uploader/Uploader';
import { UploadAction, IUploadActionProps } from './UploadAction';
import { IFileSystemDialogProps, FileSystemDialog } from '../../fileSystemDialog/FileSystemDialog';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { PlatformDetection } from '@ms/utilities-browser/lib/PlatformDetection';
import { ActionBase } from '../../action/Action';

class NoUpload extends React.PureComponent<IUploadFolderActionProps> {
    public render(): JSX.Element {
        return React.createElement(ActionBase, {});
    }
}

const platformDetection = new PlatformDetection();

const UploadFolderDialog = injectInitialProps((): Pick<IFileSystemDialogProps, 'type'> => ({ type: 'directory' }))(FileSystemDialog);

export type IUploadFolderActionProps = IDecoratedProps<IUploadActionProps, Pick<IUploaderProps, 'fileSelector'>, {}>;

export const UploadFolderAction: React.ComponentType<IUploadFolderActionProps> = platformDetection.isFolderUploadSupported ?
    injectInitialProps((): Pick<IUploaderProps, 'fileSelector'> =>
        ({ fileSelector: UploadFolderDialog }))(UploadAction) :
    NoUpload;
